import type { WithExperimentConfig } from '@shutterstock/experiments-types';
import { withVisualizedExperiment } from '@shutterstock/experiments-visualizer';

import { InlineEditingProvider } from '@/providers/InlineEditingProvider/InlineEditingProvider';

import { Variant1 } from './Variant1';

/**
 * @TODO REMOVE THIS AFTER READING
 *
 * `config` - required data about this experiment. It includes, experiment ids, and an array of it's Variants, [Variant1, Variant2, etc...]
 * The component should be a static import in most cases, but a dynamic import is supported as well.
 */

export const config: WithExperimentConfig = {
  feature: InlineEditingProvider,
  id: 'contrib-3963-inline-editing',
  variations: [Variant1],
};

export const ExperimentInlineEditingProvider = withVisualizedExperiment(config.feature, config.id, config.variations);
